import { resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_c_icon = _resolveComponent("c-icon")!

  return (_openBlock(), _createBlock(_Transition, {
    name: "o-anim-fade-200",
    mode: "out-in"
  }, {
    default: _withCtx(() => [
      (_openBlock(), _createElementBlock("button", {
        key: _ctx.active,
        type: "button",
        tabindex: "-1",
        class: "c-input__password-toggler",
        onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.toggle()), ["prevent"]))
      }, [
        _createVNode(_component_c_icon, {
          name: _ctx.active ? 'icon-eye' : 'icon-eye-line',
          class: "h-18",
          title: _ctx.$dictionary.get(_ctx.active ? 'global/generic/hidepasswordbuttontitle' : 'global/generic/showpasswordbuttontitle')
        }, null, 8, ["name", "title"])
      ]))
    ]),
    _: 1
  }))
}